<template>
  <el-dialog title="从流程模版创建活动订单" :visible.sync="visible" width="760px" :close-on-click-modal="false">
    <el-steps :active="step" finish-status="success" simple>
      <el-step title="选择模版"/><el-step title="订单信息"/><el-step title="确认"/>
    </el-steps>

    <div v-show="step === 0" class="step-content">
      <el-input v-model="templateKeyword" clearable placeholder="搜索流程模版" @keyup.enter.native="loadTemplates">
        <el-button slot="append" icon="el-icon-search" @click="loadTemplates"/>
      </el-input>
      <el-table v-loading="templateLoading" :data="templates" border stripe highlight-current-row
                @current-change="selectTemplate" class="template-table">
        <el-table-column width="50" align="center">
          <template v-slot="scope"><el-radio v-model="form.templateId" :label="scope.row.id"><span/></el-radio></template>
        </el-table-column>
        <el-table-column prop="name" label="流程模版"/>
        <el-table-column prop="dealerName" label="默认团队"/>
        <el-table-column prop="groupCount" label="流程" width="70" align="center"/>
        <el-table-column prop="stepCount" label="步骤" width="70" align="center"/>
      </el-table>
    </div>

    <div v-show="step === 1" class="step-content">
      <el-form ref="orderForm" :model="form" :rules="rules" label-width="100px">
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="订单名称" prop="name"><el-input v-model="form.name"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="活动时间" prop="eventTime"><el-date-picker v-model="form.eventTime" type="datetime" style="width:100%"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="客户名称"><el-input v-model="form.contact"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="联系电话"><el-input v-model="form.contactPhone"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="活动方"><el-input v-model="form.host"/></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="所属分销商"><el-select v-model="form.dealerId" clearable filterable style="width:100%"><el-option v-for="item in dealers" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="执行团队"><el-select v-model="form.builderIds" multiple clearable filterable style="width:100%" placeholder="可选择多个执行团队"><el-option v-for="item in dealers" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="活动接龙"><el-select v-model="form.pollNumber" clearable filterable style="width:100%" placeholder="可选；关联后接龙结束，发起人可查看订单"><el-option v-for="item in polls" :key="item.number" :label="`${item.title}（${item.number}）`" :value="item.number"/></el-select></el-form-item></el-col>
        </el-row>
      </el-form>
    </div>

    <div v-show="step === 2" class="step-content">
      <el-descriptions title="订单信息确认" :column="2" border>
        <el-descriptions-item label="流程模版">{{ selectedTemplate && selectedTemplate.name }}</el-descriptions-item>
        <el-descriptions-item label="订单名称">{{ form.name }}</el-descriptions-item>
        <el-descriptions-item label="客户名称">{{ form.contact || '未填写' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ form.contactPhone || '未填写' }}</el-descriptions-item>
        <el-descriptions-item label="活动方">{{ form.host || '未填写' }}</el-descriptions-item>
        <el-descriptions-item label="执行团队">{{ selectedBuilderNames }}</el-descriptions-item>
        <el-descriptions-item label="活动接龙">{{ selectedPollName }}</el-descriptions-item>
      </el-descriptions>
      <el-alert type="info" :closable="false" show-icon title="提交后将复制模版中的流程、步骤和反馈问题，并生成客户、执行人员和管理端二维码。"/>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="step > 0" @click="step--">上一步</el-button>
      <el-button v-if="step < 2" type="primary" :disabled="step === 0 && !form.templateId" @click="next">下一步</el-button>
      <el-button v-else type="primary" :loading="submitting" @click="submit">创建订单</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {eventtype} from "@/api/eventtype";
import {eventorder} from "@/api/eventorder";
import {user} from "@/api/user";
import {poll} from "@/api/poll";

const emptyForm = () => ({templateId: null, name: "", contact: "", contactPhone: "", host: "", eventTime: null, dealerId: null, builderIds: [], pollNumber: null});

export default {
  name: "EventOrderCreate",
  data() {
    return {
      visible: false, step: 0, templateKeyword: "", templates: [], dealers: [], polls: [],
      selectedTemplate: null, templateLoading: false, submitting: false, form: emptyForm(),
      rules: {
        name: [{required: true, message: "请输入订单名称", trigger: "blur"}],
        eventTime: [{required: true, message: "请选择活动时间", trigger: "change"}],
      },
    };
  },
  computed: {
    selectedDealerName() {
      const dealer = this.dealers.find(item => item.id === this.form.dealerId);
      return dealer ? dealer.name : "未指定";
    },
    selectedBuilderNames() {
      const names = this.dealers.filter(item => this.form.builderIds.includes(item.id)).map(item => item.name);
      return names.length ? names.join("、") : "未指定";
    },
    selectedPollName() {
      const selected = this.polls.find(item => item.number === this.form.pollNumber);
      return selected ? `${selected.title}（${selected.number}）` : "未关联";
    },
  },
  methods: {
    open() {
      this.visible = true; this.step = 0; this.form = emptyForm(); this.selectedTemplate = null;
      this.loadTemplates();
      user.listAllDealer().then(res => { this.dealers = res.data || []; });
      poll.list(100, 1).then(res => { this.polls = ((res.data && res.data.list) || []).filter(item => item.status === "ONGOING"); });
    },
    loadTemplates() {
      this.templateLoading = true;
      eventtype.list(100, 1, this.templateKeyword).then(res => { this.templates = (res.data && res.data.list) || []; })
          .finally(() => { this.templateLoading = false; });
    },
    selectTemplate(row) {
      if (!row) return;
      this.selectedTemplate = row; this.form.templateId = row.id;
    },
    next() {
      if (this.step === 0) {
        eventtype.detail(this.form.templateId).then(res => {
          const data = res.data || {};
          this.selectedTemplate = data;
          this.form.name = data.name || ""; this.form.contact = data.contact || "";
          this.form.contactPhone = data.contactPhone || ""; this.form.host = data.host || "";
          this.form.eventTime = data.eventTime ? new Date(data.eventTime) : null; this.form.dealerId = data.dealerId || null;
          this.form.builderIds = data.dealerId ? [data.dealerId] : [];
          this.step = 1;
        });
      } else {
        this.$refs.orderForm.validate(valid => { if (valid) this.step = 2; });
      }
    },
    submit() {
      const payload = {...this.form, eventTime: this.form.eventTime ? new Date(this.form.eventTime).toISOString() : null};
      this.submitting = true;
      eventorder.createFromTemplate(payload).then(res => {
        this.$message.success(`订单创建成功，订单 ID：${res.data}`);
        this.visible = false; this.$emit("created", res.data);
      }).finally(() => { this.submitting = false; });
    },
  },
};
</script>

<style scoped>
.step-content { margin-top: 22px; min-height: 260px; }
.template-table { margin-top: 12px; }
.el-alert { margin-top: 18px; }
</style>
